import type { SeverityLevel } from '@sentry/core'
import { type AxiosError, isAxiosError } from 'axios'
import { isNavigationFailure } from 'vue-router'

import { captureSentryException, captureSentryExceptionWithScope } from '@/services/telemetry/sentryClient'
import { getSentryAxiosRequestContext } from '@/services/telemetry/sentryAxiosRequestContext'
import { isSentryEnabled } from '@/services/telemetry/sentryEnv'
import { shouldIgnoreSentryAxiosError, type ApiErrorData } from '@/services/telemetry/shouldIgnoreSentryAxiosError'
import { useCommonStore } from '@/stores'

export function errorHandler(error: unknown, level?: SeverityLevel): void {
    const commonStore = useCommonStore()

    if (isNavigationFailure(error)) {
        commonStore.toggleMainLoader(false)
    }

    if (!isSentryEnabled()) {
        return
    }

    if (isAxiosError<ApiErrorData>(error)) {
        if (shouldIgnoreSentryAxiosError(error)) {
            return
        }

        const requestUrl = error.config?.url || ''

        captureSentryExceptionWithScope(error, (scope) => {
            if (level) {
                scope.setLevel(level)
            }

            scope.setFingerprint(['', requestUrl || 'unknown'])
            scope.setExtra('API request', getSentryAxiosRequestContext(error))
            scope.setExtra('API response', error.response?.data ?? null)
        })

        return
    }

    if (level) {
        captureSentryExceptionWithScope(error, (scope) => {
            scope.setLevel(level)
        })
        return
    }

    captureSentryException(error)
}
